"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSSwarm = _interopRequireDefault(require("./FDS-Swarm.js"));

var _Multibox = _interopRequireDefault(require("./contracts/Multibox.js"));

var _KeyValueTree = _interopRequireDefault(require("./contracts/KeyValueTree.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class Multibox {
  constructor(account, config) {
    this.account = account;
    this.con = null;
    this.roots = null;
    this.contractAddress = null;
    this.rootKvt = null;
    this.kvts = null;
    this.Store = new _FDSSwarm.default(config, account);
  }

  at(address) {
    var _this = this;

    return _asyncToGenerator(function* () {
      _this.mb = yield new _Multibox.default(_this.account, address);
      _this.contractAddress = address;
      _this.roots = yield _this.mb.getRoots();
      _this.rootKvt = new _KeyValueTree.default(_this.account, _this.roots[0]);
      _this.kvts = _this.roots.map(root => new _KeyValueTree.default(_this.account, root));
      return _this;
    })();
  }

  deploy() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      _this2.mb = yield new _Multibox.default(_this2.account);
      _this2.contractAddress = _this2.mb.contractAddress;
      _this2.roots = yield _this2.mb.getRoots();
      _this2.rootKvt = new _KeyValueTree.default(_this2.account, _this2.roots[0]);
      _this2.kvts = _this2.roots.map(root => new _KeyValueTree.default(_this2.account, root));
      return _this2;
    })();
  } // note - we should use something other than swarm digest id's here eg. encrypted strings in multibox contract
  // it's unnecessarily expensive and also prone requires swarm hashes to be available from network in order to work
  // note - would be good to check these in reverse to avoid unneccesary calls


  get(path) {
    var _arguments = arguments,
        _this3 = this;

    return _asyncToGenerator(function* () {
      var retrievePathNames = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
      return _this3.retrievePathValues(path, retrievePathNames);
    })();
  }

  set(path, key, value) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      yield _this4.createPath(path);
      var nodeId = yield _this4.Store.getSwarmDigest(path);
      return _this4.rootKvt.setKeyValue(nodeId, key, value);
    })();
  }

  createPath(path, value) {
    var _arguments2 = arguments,
        _this5 = this;

    return _asyncToGenerator(function* () {
      var kvti = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : 0;
      var parentNodeId;
      var splitPath = path.split('/').slice(1);

      if (splitPath[0] === 'root') {
        //do nothing
        parentNodeId = yield _this5.rootKvt.getRootId();
      } else if (splitPath[0] === 'shared') {
        parentNodeId = yield _this5.rootKvt.getSharedId();
      } else {
        throw new Error('path must begin /shared or /root');
      }

      for (var i = 0; i < splitPath.length - 1; i++) {
        var currentPath = '/' + splitPath.slice(0, i + 2).join('/');
        var newNodeId = yield _this5.Store.getSwarmDigest(currentPath);
        var addChildNode = yield _this5.rootKvt.addChildNode(parentNodeId, newNodeId);
        parentNodeId = newNodeId;
      }

      return true;
    })();
  }

  retrieveValues(nodeId) {
    var _this6 = this;

    return _asyncToGenerator(function* () {
      var keyValues = {};
      var keyValuesRaw = yield _this6.rootKvt.getKeyValues(nodeId);
      var keys = keyValuesRaw['keys'];

      for (var i = 0; i < keys.length; i++) {
        keyValues[keys[i]] = keyValuesRaw['values'][i];
      }

      return keyValues;
    })();
  }

  retrieveTree(nodeId) {
    var _arguments3 = arguments,
        _this7 = this;

    return _asyncToGenerator(function* () {
      var values = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : false;
      var retrievePathNames = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : false;
      var output = {
        id: nodeId,
        parentId: false
      };
      var children = yield _this7.rootKvt.getChildren(nodeId);

      if (retrievePathNames === true) {
        var pathName = yield _this7.Store.getSwarmDigestValue(nodeId);
        output.name = pathName;
      }

      if (children.length === 0 && values === false) {
        output = {
          id: nodeId,
          parentId: false
        };
      } else if (children.length === 0 && values === true) {
        output.values = yield _this7.retrieveValues(nodeId);
      } else {
        output.values = yield _this7.retrieveValues(nodeId);
        output.children = yield _this7.retrievesDescendants(nodeId, values, retrievePathNames);
      }

      return output;
    })();
  }

  retrievesDescendants(nodeId) {
    var _arguments4 = arguments,
        _this8 = this;

    return _asyncToGenerator(function* () {
      var values = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : false;
      var retrievePathNames = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : false;
      var children = yield _this8.rootKvt.getChildren(nodeId);
      var output = [];

      for (var i = 0; i < children.length; i++) {
        var descendants = yield _this8.retrievesDescendants(children[i], values, retrievePathNames);
        var childOutput = {
          id: children[i],
          parentId: nodeId
        };

        if (retrievePathNames === true) {
          var pathName = yield _this8.Store.getSwarmDigestValue(children[i]);
          childOutput.name = pathName;
        }

        if (descendants.length > 0) {
          childOutput.children = descendants;
          output.push(childOutput);
        } else {
          var keyValues = {};

          if (values === true) {
            keyValues = yield _this8.retrieveValues(children[i]);
          }

          childOutput.values = keyValues;
          output.push(childOutput);
        }
      }

      return output;
    })();
  } // retrieves tree structure only of path eg. /shared/mail


  retrievePathNodes(path) {
    var _this9 = this;

    return _asyncToGenerator(function* () {
      var nodeId = yield _this9.Store.getSwarmDigest(path);
      return yield _this9.retrieveTree(nodeId, false, false);
    })();
  } // retrieves tree structure and keyvalues of path eg. /shared/mail


  retrievePathValues(path, retrievePathNames) {
    var _this10 = this;

    return _asyncToGenerator(function* () {
      var nodeId = yield _this10.Store.getSwarmDigest(path);
      return yield _this10.retrieveTree(nodeId, true, retrievePathNames);
    })();
  }

}

var _default = Multibox;
exports.default = _default;
module.exports = exports.default;